var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.fileName === 'zeRenMianChu')?_c('ZeRenMianChu'):(_vm.fileName === 'teBieYueDing')?_c('TeBieYueDing'):_c('GeRenXinXiShouQuan')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }